/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectItemCommand } from '../../models/create-project-item-command';
import { CreateProjectItemCommandResult } from '../../models/create-project-item-command-result';

export interface ApiProjectItemCreateProjectItemPost$Params {
      body?: CreateProjectItemCommand
}

export function apiProjectItemCreateProjectItemPost(http: HttpClient, rootUrl: string, params?: ApiProjectItemCreateProjectItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectItemCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemCreateProjectItemPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectItemCommandResult>;
    })
  );
}

apiProjectItemCreateProjectItemPost.PATH = '/api/ProjectItem/CreateProjectItem';
